module.exports = __webpack_public_path__ + "img/brand--inkafarma.1355dd3a.png";